/* Les Femmes Célèbres — page « Le calendrier » : portraits défilants + 12 mois
   Identique dans l'aperçu et le thème Shopify. */
(function () {
  'use strict';
  var DATA = window.LFC || [];
  var IMG  = window.LFC_IMAGE_BASE || '';
  var lien = window.LFC_LIEN || function (h) { return '/blogs/' + (window.LFC_BLOG || 'calendrier-des-femmes-celebres') + '/' + h; };
  var MOIS = ['janvier','février','mars','avril','mai','juin','juillet','août',
              'septembre','octobre','novembre','décembre'];
  var NB_PORTRAITS = 30;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function annee(e) { var m = /(\d{4})/.exec(e.a || ''); return m ? m[1] : ''; }
  var LOGO = '6689_logomark-rond-348x348px.jpg';          // à défaut de portrait
  function vignette(w) {
    return '<img class="lfcal-jour__p' + (w.i ? '' : ' lfcal-jour__p--logo') + '" src="' +
           IMG + encodeURIComponent(w.i || LOGO) + '" alt="" loading="lazy" width="22" height="22">';
  }

  /* ---------- rangée de portraits en fondu (même principe que la page d'accueil) ---------- */
  var hote = document.getElementById('lfcal-ronde');
  if (hote) {
    var SELECTION = ["elisa-deroche", "marie-anne-lavoisier", "alice-mathieu-dubois", "rose-valland", "simone-michel-levy", "dorothy-vaughan", "adrienne-bolland", "sarah-breedlove", "colette", "katherine-johnson", "helene-vagliano", "sofia-kovalevskaia", "maria-goeppert-mayer", "hubertine-auclert", "mata-amritanandamayi", "madeleine-bres", "ada-blackjack", "wangari-muta-maathai", "anne-franck", "fe-del-mundo", "ichiyo-higuchi", "toni-morrison", "marguerite-yourcenar"];
    var parHandle = {};
    function slug(t) {
      return String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    DATA.forEach(function (e) {
      parHandle[e.h] = e;
      // les femmes ajoutées à la suite d'un jour : repérées par leur nom, lien vers la fiche du jour
      (e.s || []).forEach(function (w) {
        var k = w.h || slug(w.n);
        if (!parHandle[k]) parHandle[k] = { n: w.n, i: w.i, h: e.h };
      });
    });
    // portraits recadrés plus serrés sur le visage, pour les médaillons seulement
    var MEDAILLON = {
      'marie-anne-lavoisier': '7722_MARIE-ANNE-LAVOISIER-medaillon.jpg',
      'madeleine-pelletier': '4268_Madeleine-PELLETIER-medaillon.jpg',
      'alice-mathieu-dubois': 'wm_alice-mathieu-dubois-medaillon.jpg',
      'hubertine-auclert': '7771_Hubertine-Auclert-medaillon.jpg',
      'anne-franck': '4295_Anne-FRANCK-medaillon.jpg'
    };
    var pool = SELECTION.map(function (h) {
      var e = parHandle[h];
      if (e && MEDAILLON[h]) e = { n: e.n, i: MEDAILLON[h], h: e.h };
      return e;
    }).filter(function (e) { return e && e.i; });
    if (!pool.length) {                        // repli : répartis sur l'année
      var avec = DATA.filter(function (e) { return e.i; });
      var pas = avec.length / NB_PORTRAITS;
      for (var i = 0; i < NB_PORTRAITS && i < avec.length; i++) pool.push(avec[Math.floor(i * pas)]);
    }
    var NB = Math.min(6, pool.length);
    var html = '';
    for (var b = 0; b < NB; b++) {
      html += '<a class="lfc-hero__bulle" style="--i:' + b + '" href="' + lien(pool[b].h) + '" title="' + esc(pool[b].n) + '">' +
              '<img src="' + IMG + encodeURIComponent(pool[b].i) + '" alt="' + esc(pool[b].n) + '"></a>';
    }
    hote.className = 'lfc-hero__ronde';
    hote.innerHTML = html;

    // les suivantes prennent leur place tour à tour, en fondu
    if (pool.length > NB && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var suivant = NB, slot = 0;
      setInterval(function () {
        var a = hote.children[slot], e = pool[suivant % pool.length];
        var neuf = document.createElement('img');
        neuf.src = IMG + encodeURIComponent(e.i); neuf.alt = e.n; neuf.className = 'entre';
        a.appendChild(neuf); a.href = lien(e.h); a.title = e.n;
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          neuf.classList.remove('entre');
          var ancien = a.querySelector('img:not(.entre)');
          if (ancien && ancien !== neuf) {
            ancien.classList.add('sort');
            setTimeout(function () { ancien.remove(); }, 900);
          }
        }); });
        suivant++; slot = (slot + 1) % NB;
      }, 2200);
    }
  }

  /* ---------- grille des 12 mois ---------- */
  var grid = document.getElementById('lfcal-grid');
  if (grid) {
    var parJour = {};
    DATA.forEach(function (e) { parJour[e.k] = e; });
    var JOURS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var out = '';
    for (var m = 1; m <= 12; m++) {
      out += '<section class="lfcal-mois"><h2 class="lfcal-mois__t">' + MOIS[m - 1] + '</h2><div class="lfcal-liste">';
      for (var j = 1; j <= JOURS[m - 1]; j++) {
        var e = parJour[pad(m) + '-' + pad(j)];
        if (e) {
          out += '<a class="lfcal-jour" href="' + lien(e.h) + '">' +
                 '<span class="lfcal-jour__n">' + pad(j) + '</span>' + vignette(e) +
                 '<span class="lfcal-jour__nom">' + esc(e.n) + '</span>' +
                 '<span class="lfcal-jour__an">' + annee(e) + '</span></a>';
          // les femmes ajoutées à la suite du même jour
          (e.s || []).forEach(function (w) {
            out += '<a class="lfcal-jour lfcal-jour--bis" href="' + lien(e.h) + '">' +
                   '<span class="lfcal-jour__n"></span>' + vignette(w) +
                   '<span class="lfcal-jour__nom">' + esc(w.n) + '</span>' +
                   '<span class="lfcal-jour__an">' + annee(w) + '</span></a>';
          });
        } else {
          out += '<span class="lfcal-jour lfcal-jour--vide"><span class="lfcal-jour__n">' + pad(j) +
                 '</span><span class="lfcal-jour__p"></span><span class="lfcal-jour__nom">à venir</span><span></span></span>';
        }
      }
      out += '</div></section>';
    }
    grid.innerHTML = out;
  }
})();
